import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登陆'
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: () => import(/* webpackChunkName: "index" */ '../views/index.vue'),
    redirect: '/index/welcome',
    children: [
      {
        path: 'welcome',
        name: 'welcome',
        meta: {
          title: '首页',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "welcome" */ '../views/welcome.vue')
      },
      {
        path: 'clientManagement',
        name: 'clientManagement',
        meta: {
          title: '客户管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "clientManagement" */ '../views/clientManagement/index.vue'),
        children: [
          {
            path: 'clientManagement',
            name: 'clientManagementList',
            meta: {
              title: '客户管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "clientManagement" */ '../views/clientManagement/clientManagement.vue')
          },
          {
            path: 'clientType',
            name: 'clientType',
            meta: {
              title: '客户类型',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "clientType" */ '../views/clientManagement/clientType.vue')
          },
        ]
      },
      {
        path: 'goodsManagement',
        name: 'goodsManagement',
        meta: {
          title: '商品管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "goodsManagement" */ '../views/goodsManagement/index.vue'),
        children: [
          {
            path: 'goodsCategory',
            name: 'goodsCategory',
            meta: {
              title: '商品分类',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "goodsCategory" */ '../views/goodsManagement/goodsCategory.vue')
          },
          {
            path: 'customableGoods',
            name: 'customableGoods',
            meta: {
              title: '可订商品管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customableGoods" */ '../views/goodsManagement/customableGoods.vue')
          },
          {
            path: 'customableGoodsSku',
            name: 'customableGoodsSku',
            meta: {
              title: '可订商品管理(规格)',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customableGoodsSku" */ '../views/goodsManagement/customableGoodsSku.vue')
          },
          {
            path: 'addGoods',
            name: 'addGoods',
            meta: {
              title: '新增/编辑商品',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "addGoods" */ '../views/goodsManagement/addGoods.vue')
          },
          {
            path: 'warehouseWarrant',
            name: 'warehouseWarrant',
            meta: {
              title: '可订数量录入',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "warehouseWarrant" */ '../views/goodsManagement/warehouseWarrant.vue')
          },
          {
            path: 'sourceTracingManagement',
            name: 'sourceTracingManagement',
            meta: {
              title: '溯源管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "sourceTracingManagement" */ '../views/goodsManagement/sourceTracingManagement.vue')
          }
        ]
      },
      {
        path: 'orderManagement',
        name: 'orderManagement',
        meta: {
          title: '订单管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "orderManagement" */ '../views/orderManagement/index.vue'),
        children: [
          {
            path: 'availableOrder',
            name: 'availableOrder',
            meta: {
              title: '订单列表',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "availableOrder" */ '../views/orderManagement/availableOrder.vue')
          },
          {
            path: 'replenishment',
            name: 'replenishment',
            meta: {
              title: '补货录入',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "replenishment" */ '../views/orderManagement/replenishment.vue')
          },
          {
            path: 'addOrder',
            name: 'addOrder',
            meta: {
              title: '新增/修改订单',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "addOrder" */ '../views/orderManagement/addOrder.vue')
          },
          {
            path: 'orderDetail',
            name: 'orderDetail',
            meta: {
              title: '订单详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "orderDetail" */ '../views/orderManagement/orderDetails.vue')
          },
          {
            path: 'preOrder',
            name: 'preOrder',
            meta: {
              title: '预定订单',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "preOrder" */ '../views/orderManagement/preOrder.vue')
          },
          {
            path: 'addPreOrder',
            name: 'addPreOrder',
            meta: {
              title: '新增/修改预定订单',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "addPreOrder" */ '../views/orderManagement/addPreOrder.vue')
          },
          {
            path: 'preOrderDetail',
            name: 'preOrderDetail',
            meta: {
              title: '预定订单详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "preOrderDetail" */ '../views/orderManagement/preOrderDetails.vue')
          }
        ]
      },
      {
        path: 'collectManagement',
        name: 'collectManagement',
        meta: {
          title: '汇总管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "collectManagement" */ '../views/collectManagement/index.vue'),
        children: [
          {
            path: 'customableCollect',
            name: 'customableCollect',
            meta: {
              title: '可订订单汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customableCollect" */ '../views/collectManagement/customableCollect.vue')
          },
          {
            path: 'reserveCollect',
            name: 'reserveCollect',
            meta: {
              title: '预订订单汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "reserveCollect" */ '../views/collectManagement/reserveCollect.vue')
          },
          {
            path: 'shipmentsCollect',
            name: 'shipmentsCollect',
            meta: {
              title: '商品发货汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "shipmentsCollect" */ '../views/collectManagement/shipmentsCollect.vue')
          },
          {
            path: 'customerDeliverySummary',
            name: 'customerDeliverySummary',
            meta: {
              title: '客户发货汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customerDeliverySummary" */ '../views/collectManagement/customerDeliverySummary.vue')
          },
          {
            path: 'dailySalesSummary',
            name: 'dailySalesSummary',
            meta: {
              title: '销售额日汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "dailySalesSummary" */ '../views/collectManagement/dailySalesSummary.vue')
          },
          {
            path: 'dailyPaymentSummary',
            name: 'dailyPaymentSummary',
            meta: {
              title: '回款额日汇总',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "dailyPaymentSummary" */ '../views/collectManagement/dailyPaymentSummary.vue')
          }
        ]
      },
      {
        path: 'examineManagement',
        name: 'examineManagement',
        meta: {
          title: '验收管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "examineManagement" */ '../views/examineManagement/index.vue'),
        children: [
          {
            path: 'receivingManagement',
            name: 'receivingManagement',
            meta: {
              title: '收货管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "receivingManagement" */ '../views/examineManagement/receivingManagement.vue')
          },
          {
            path: 'receivingDetail',
            name: 'receivingDetail',
            meta: {
              title: '收货详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "receivingDetail" */ '../views/examineManagement/receivingDetail.vue')
          },
          {
            path: 'exceptionHandling',
            name: 'exceptionHandling',
            meta: {
              title: '异常处理',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "exceptionHandling" */ '../views/examineManagement/exceptionHandling.vue')
          },
          {
            path: 'abnormalCompletion',
            name: 'abnormalCompletion',
            meta: {
              title: '异常完成',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "abnormalCompletion" */ '../views/examineManagement/abnormalCompletion.vue')
          },
          {
            path: 'exceptionManagement',
            name: 'exceptionManagement',
            meta: {
              title: '异常管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "exceptionManagement" */ '../views/examineManagement/exceptionManagement.vue')
          },
          {
            path: 'exceptionManagementDetail',
            name: 'exceptionManagementDetail',
            meta: {
              title: '异常详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "exceptionManagementDetail" */ '../views/examineManagement/exceptionManagementDetail.vue')
          },
          {
            path: 'damageRecord',
            name: 'damageRecord',
            meta: {
              title: '损坏记录',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "damageRecord" */ '../views/examineManagement/damageRecord.vue')
          },
          {
            path: 'damageRecordDetail',
            name: 'damageRecordDetail',
            meta: {
              title: '损坏记录详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "damageRecordDetail" */ '../views/examineManagement/damageRecordDetail.vue')
          },
          {
            path: 'abnormalReceipt',
            name: 'abnormalReceipt',
            meta: {
              title: '收货异常',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "abnormalReceipt" */ '../views/examineManagement/abnormalReceipt.vue')
          },
          {
            path: 'abnormalReceiptDetail',
            name: 'abnormalReceiptDetail',
            meta: {
              title: '收货异常详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "abnormalReceiptDetail" */ '../views/examineManagement/abnormalReceiptDetail.vue')
          },
          {
            path: 'returnManagement',
            name: 'returnManagement',
            meta: {
              title: '退货管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "returnManagement" */ '../views/examineManagement/returnManagement.vue')
          },
          {
            path: 'returnManagementDetail',
            name: 'returnManagementDetail',
            meta: {
              title: '详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "returnManagementDetail" */ '../views/examineManagement/returnManagementDetail.vue')
          },
          {
            path: 'chargeback',
            name: 'chargeback',
            meta: {
              title: '退单管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "chargeback" */ '../views/examineManagement/chargeback.vue')
          },
          {
            path: 'chargebackDetail',
            name: 'chargebackDetail',
            meta: {
              title: '详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "chargebackDetail" */ '../views/examineManagement/chargebackDetail.vue')
          },
          {
            path: 'refundRecord',
            name: 'refundRecord',
            meta: {
              title: '退款记录',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "refundRecord" */ '../views/examineManagement/refundRecord.vue')
          }
        ]
      },
      {
        path: 'settlementManagement',
        name: 'settlementManagement',
        meta: {
          title: '结算管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "settlementManagement" */ '../views/settlementManagement/index.vue'),
        children: [
          {
            path: 'settlementManagement',
            name: 'settlementManagement',
            meta: {
              title: '结算单',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "settlementManagementList" */ '../views/settlementManagement/settlementManagement.vue')
          },
          {
            path: 'priceAdjustmentRecord',
            name: 'priceAdjustmentRecord',
            meta: {
              title: '调价记录',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "priceAdjustmentRecord" */ '../views/settlementManagement/priceAdjustmentRecord.vue')
          },
          {
            path: 'priceAdjustmentRecordDetail',
            name: 'priceAdjustmentRecordDetail',
            meta: {
              title: '调价记录详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "priceAdjustmentRecordDetail" */ '../views/settlementManagement/priceAdjustmentRecordDetail.vue')
          },
          {
            path: 'settlementManagementDetail',
            name: 'settlementManagementDetail',
            meta: {
              title: '结算详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "settlementManagementDetail" */ '../views/settlementManagement/settlementManagementDetail.vue')
          },
          {
            path: 'collectionManagement',
            name: 'collectionManagement',
            meta: {
              title: '收款管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "collectionManagement" */ '../views/settlementManagement/collectionManagement.vue')
          },
          {
            path: 'myCollectionManagement',
            name: 'myCollectionManagement',
            meta: {
              title: '我的收款管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "myCollectionManagement" */ '../views/settlementManagement/myCollectionManagement.vue')
          },
          {
            path: 'addCollection',
            name: 'addCollection',
            meta: {
              title: '财务收款',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "addCollection" */ '../views/settlementManagement/addCollection.vue')
          },
          {
            path: 'collectionManagementDetail',
            name: 'collectionManagementDetail',
            meta: {
              title: '收款详情',
              grade: 2
            },
            component: () => import(/* webpackChunkName: "collectionManagementDetail" */ '../views/settlementManagement/collectionManagementDetail.vue')
          },
          {
            path: 'unpaidManagement',
            name: 'unpaidManagement',
            meta: {
              title: '客户待付管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "unpaidManagement" */ '../views/settlementManagement/unpaidManagement.vue')
          },
          {
            path: 'myPendingManagement',
            name: 'myPendingManagement',
            meta: {
              title: '我的待收管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "myPendingManagement" */ '../views/settlementManagement/myPendingManagement.vue')
          },
          {
            path: 'customerBalance',
            name: 'customerBalance',
            meta: {
              title: '客户余额管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customerBalance" */ '../views/settlementManagement/customerBalance.vue')
          },
          {
            path: 'customerReconciliation',
            name: 'customerReconciliation',
            meta: {
              title: '客户对账管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customerReconciliation" */ '../views/settlementManagement/customerReconciliation.vue')
          },
          {
            path: 'customerMonthlySettlement',
            name: 'customerMonthlySettlement',
            meta: {
              title: '客户月结算明细',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "customerMonthlySettlement" */ '../views/settlementManagement/customerMonthlySettlement.vue')
          }
        ]
      },
      {
        path: 'unionpay',
        name: 'unionpay',
        meta: {
          title: '银联',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "unionpay" */ '../views/unionpay/index.vue'),
        children: [
          {
            path: 'unionpayMarketplaceList',
            name: 'unionpayMarketplaceList',
            meta: {
              title: '账户列表',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "unionpayMarketplaceList" */ '../views/unionpay/marketplaceList.vue')
          },
          {
            path: 'unionpayMerchantList',
            name: 'unionpayMerchantList',
            meta: {
              title: '商户列表',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "unionpayMerchantList" */ '../views/unionpay/merchantList.vue')
          },
          {
            path: 'unionpayAppList',
            name: 'unionpayAppList',
            meta: {
              title: '支付配置',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "unionpayAppList" */ '../views/unionpay/appList.vue')
          }
        ]
      },
      {
        path: 'agBank',
        name: 'agBank',
        meta: {
          title: '农业银行',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "agBank" */ '../views/agBank/index.vue'),
        children: [
          {
            path: 'agBankMerchant',
            name: 'agBankMerchant',
            meta: {
              title: '商户列表',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "agBankMerchant" */ '../views/agBank/merchantList.vue')
          },
          {
            path: 'agBankAppList',
            name: 'agBankAppList',
            meta: {
              title: '支付配置',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "appList" */ '../views/agBank/appList.vue')
          }
        ]
      },
      {
        path: 'operatorManagement',
        name: 'operatorManagement',
        meta: {
          title: '操作员管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "operatorManagement" */ '../views/operatorManagement/index.vue'),
        children: [
          {
            path: 'operator',
            name: 'operator',
            meta: {
              title: '操作员管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "operator" */ '../views/operatorManagement/operator.vue')
          },
          {
            path: 'role',
            name: 'role',
            meta: {
              title: '角色管理',
              grade: 1
            },
            component: () => import(/* webpackChunkName: "role" */ '../views/operatorManagement/role.vue')
          }
        ]
      },
      {
        path: 'synchronousException',
        name: 'synchronousException',
        meta: {
          title: '同步异常',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "synchronousException" */ '../views/synchronousException/synchronousException.vue')
      },
      {
        path: 'template',
        name: 'template',
        meta: {
          title: '模板管理',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "template" */ '../views/template/template.vue')
      },
      {
        path: 'paymentBank',
        name: 'paymentBank',
        meta: {
          title: '设置支付银行',
          grade: 1
        },
        component: () => import(/* webpackChunkName: "paymentBank" */ '../views/paymentBank/paymentBank.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});


router.beforeEach((to, from, next) => {
  if (typeof (to.meta?.title) === 'string') {
    window.document.title = to.meta.title;
  }
  next();
});

export default router;
